import { Options } from 'vue-class-component';
import {
  DateAndTimeTrigger,
  WaitTimeAction,
} from '@/../client-generator/generated-clients/plants';
import SceneTimeObject from '../SceneTimeObject/SceneTimeObject';

@Options({
  name: 'SceneTimeObjectInline',
  props: {
    timeObject: {
      type: Object,
      required: true,
    },
  },
})
export default class SceneTimeObjectInline extends SceneTimeObject {
  get waitTime(): string {
    if (!this.polymorphicTimeObject) return '';
    let time: string;
    const splitWaitTime = (this
      .polymorphicTimeObject as WaitTimeAction).waitTime?.split(':');
    if (splitWaitTime![0] === '00') {
      time = `${splitWaitTime![1]}:${splitWaitTime![2]}`;
    } else {
      time = `${splitWaitTime![0]}:${splitWaitTime![1]}`;
    }

    return time;
  }

  get timeTrigger(): string {
    if (!this.polymorphicTimeObject) return '';

    return ((this.polymorphicTimeObject as DateAndTimeTrigger)
      .time as string).substr(0, 5);
  }
}
